import { render, staticRenderFns } from "./SendingSmsStudentSearch.vue?vue&type=template&id=2f044bd3"
import script from "./SendingSmsStudentSearch.vue?vue&type=script&lang=js"
export * from "./SendingSmsStudentSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports